import { createHttpClient } from '@sportpark/shared/http-client';

export {
  ApiError,
  type ApiProblem,
  type RequestOptions,
  type StoredSession,
} from '@sportpark/shared/http-client';

export const AUTH_STORAGE_KEY = 'sportpark.auth';

const client = createHttpClient({
  storageKey: AUTH_STORAGE_KEY,
});

export const readSession = client.readSession;
export const writeSession = client.writeSession;
export const subscribeSession = client.subscribe;
export const keepSessionFresh = client.keepFresh;
export const ensureFreshAccessToken = client.ensureFreshAccessToken;
export const renewAccessToken = client.renewAccessToken;
export const request = client.request;
export const http = client.http;
